import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { Mandoob } from '../mandoob.model';
import { MandoobService } from '../mandoob.service';

@Component({
  selector: 'app-addmandoob',
  templateUrl: './addmandoob.component.html',
  styleUrls: ['./addmandoob.component.css']
})
export class AddmandoobComponent implements OnInit {

  mandoob: Mandoob = {} as Mandoob;
  updateMode = false;
  spinnerOverlay = false;
  
  constructor(private router: Router, 
    private service: MandoobService, 
    private globle: Globle,
    private snackBar:MatSnackBar,
    private activateRoute:ActivatedRoute,
    private translate:TranslateService,
    private localStorage:LocalStorageService) { }

  ngOnInit(): void {
    this.mandoob.canUpdateUserCategory = false;
    this.getUrlParam();
  }


  getUrlParam(){
    this.activateRoute.paramMap.subscribe(param => {
      if(param.get("id") != null){
     this.mandoob.id = +param.get("id")!;
     this.updateMode = true;
     this.getById();
      }
    })
  }

  getById(){
    this.spinnerOverlay = true;
    this.service.getById(this.mandoob.id).subscribe(data => {
      this.mandoob = data
      this.spinnerOverlay = false;
      
    },error => {
      console.log(error);
      this.spinnerOverlay = false;
    })
  }

  back() {
    this.router.navigate(["./master/options/mandoobsList"]);
  }

  submit() {
    this.spinnerOverlay = true;
    !this.updateMode ? this.create() : this.update();
  }

  create() {

    this.service.Create(this.mandoob).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("createdSuccessfully"),'snackBarSuccess');
      this.back();
    },
      error => {
        console.log(error);
        if(error.error.message != undefined){
        this.openSnackBar(error.error.message,'snackBarError');
        }
        else{
          this.openSnackBar("Internal server error",'snackBarError');
        }
        
        this.spinnerOverlay = false;
      })
  }

  update() {

    this.service.Update(this.mandoob).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("updatedSuccessfully"),'snackBarSuccess');
      this.back();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        if(error.error.message != undefined){
          this.openSnackBar(error.error.message,'snackBarError');
          }
          else{
            this.openSnackBar("Internal server error",'snackBarError');
          }
        
      })
  }

  openSnackBar(message:any,cssclass:any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass:cssclass
      
    });
  }

}
